/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2024.
 */

import { SxProps } from '@mui/material';

export const headerItemStackSX: SxProps = {
	color: 'text.primary',
	'&:hover': {
		color: 'primary.main',
	},
	lineHeight: 0,
	cursor: 'pointer',
};

export const headerItemCartSX = (productsAvailable: boolean): SxProps => ({
	lineHeight: 0,
	cursor: 'pointer',
	'*': {
		color: productsAvailable ? 'primary.main' : 'text.primary',
		'&:hover': {
			color: productsAvailable ? 'primary.main' : 'text.primary',
		},
	},
});
